<template>
<v-app>
  <section class="portfolio" id="portfolio">
		<div class="top-right-separator hidden-xs"></div>
		<div class="container">
			<div class="section-title-parralax">
				<div  class="process-numbers" style="text-align: center;">PORTFOLIO</div> 
				<h2 >portfolio</h2>
				 <p class="module-subtitle" style="color: black;">Here's some of my work.</p>
			</div>
			<!-- categories  -->
			<div class="col-md-3">
				<div class="row categories-grid">
					<nav class="categories">
						<ul class="portfolio_filter">
							<li><a href="" class="active" data-filter="*">all</a></li>
							<li><a href="" data-filter=".vue">VueJs</a></li>
							<li><a href="" data-filter=".mongo">MongoDB</a></li>
							<li><a href="" data-filter=".wordpress">Wordpress</a></li>
							<li><a href="" data-filter=".vuetify">Vuetify</a></li>
							<li><a href="" data-filter=".express">ExpressJS</a></li>
							<li><a href="" data-filter=".node">NodeJS</a></li>
							<li><a href="" data-filter=".bulma">Bulma</a></li>
							<li><a href="" data-filter=".bootstrap">Bootstrap</a></li>
							<li><a href="" data-filter=".snipcart">Snipcart</a></li>
							<li><a href="" data-filter=".angular">Angular</a></li>
							<li><a href="" data-filter=".sass">SASS</a></li>
						</ul>
					</nav>
				</div>
			</div>

			<!-- all works -->
			<div class="col-md-9">
				<div class="row portfolio_container">
					<!-- single work -->
					<div class="col-md-4 vue">
							<div class="portfolio_item work-grid">
								<img src="/static/assets/img/bash1.png" alt="image">
									<div class="portfolio_item_hover">
										<div class="item_info">
											<span>Bashor & Legendre</span>
											<v-btn flat @click.stop="dialog = true">view</v-btn>
										</div>
								</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat class="col-md-5" style="background-color: white !important;">
										<h4>{{items[0].title}}</h4>
										<p class="portP">{{items[0].subtitle}}</p>
										<p class="portP">{{items[0].description}}</p>
										<p class="portP"><span style="font-weight: 700;">Tools: </span>{{items[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="http://www.blcpas.com/#/" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					
					<!-- end single work -->

					<!-- single work -->
					<div class="col-md-4 mongo angular express node bulma sass">
							<div class="portfolio_item work-grid">
								<img src="/static/assets/img/quickrlists1.png" alt="image">
								<div class="portfolio_item_hover">
									<div class="item_info">
										<span>Quickr Lists</span>
										<v-btn flat @click.stop="dialog2 = true">view</v-btn>
									</div>
								</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog2" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items2" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat class="col-md-5" style="background-color: white !important;">
										<h4>{{items2[0].title}}</h4>
										
										<p class="portP">{{items2[0].subtitle}}</p>
										<p class="portP">For demo, log in as <strong>demo@quickrlists.com</strong><br> Password:  <strong>test1234</strong></p>
										<p class="portP">{{items2[0].description}}</p>
										<p class="portP"><span style="font-weight: 700;">Tools: </span>{{items2[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="http://quickrlists.com/" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					<!-- end single work -->
					
					<!-- single work -->
					<div class="col-md-4 wordpress">
						<div class="portfolio_item work-grid">
							<img src="/static/assets/img/cyber1.png" alt="image">
							<div class="portfolio_item_hover">
								<div class="item_info">
									<span>{{items12[0].title}}</span>
									<v-btn flat @click.stop="dialog12 = true">view</v-btn>
								</div>
							</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog12" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items12" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat xs12 md5 class="col-md-5" style="background-color: white !important;">
										<h4>{{items12[0].title}}</h4>
										<p class="portP">{{items12[0].subtitle}}</p>
										<p class="portP">{{items12[0].description}}</p>
										<p class="portP"><span style="font-weight: 700;">Tools: </span>{{items12[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="https://www.cyberdreamvr.com/" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					<!-- end single work -->
					
					<!-- single work -->
					<div class="col-md-4 vue bootstrap snipcart node express">
						<div class="portfolio_item work-grid">
							<img src="/static/assets/img/shea1.png" alt="image">
							<div class="portfolio_item_hover">
								<div class="item_info">
									<span>SHEA BATH & BODY</span>
									<v-btn flat @click.stop="dialog9 = true">view</v-btn>
								</div>
							</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog9" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items9" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat xs12 md5 class="col-md-5" style="background-color: white !important;">
										<h4>{{items9[0].title}}</h4>
										<p class="portP">{{items9[0].subtitle}}</p>
										<p class="portP">{{items9[0].description}}</p>
										<p class="portP"><span style="font-weight: 700;">Tools: </span>{{items9[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="https://sheabathandbody.com/" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					<!-- end single work -->
										<!-- single work -->
					<div class="col-md-4 vue vuetify">
						<div class="portfolio_item work-grid">
							<img src="/static/assets/img/dwerve1.png" alt="image">
							<div class="portfolio_item_hover">
								<div class="item_info">
									<span>DWERVE</span>
									<v-btn flat @click.stop="dialog10 = true">view</v-btn>
								</div>
							</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog10" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items10" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat xs12 md5 class="col-md-5" style="background-color: white !important;">
										<h4>{{items10[0].title}}</h4>
										<p class="portP">{{items10[0].subtitle}}</p>
										<p class="portP">{{items10[0].description}}</p>
										<p class="portP"><span style="font-weight: 700;">Tools: </span>{{items10[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="https://dwerve.com" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					<!-- end single work -->
					<!-- single work -->
					<div class="col-md-4 vue bulma">
						<div class="portfolio_item work-grid">
							<img src="/static/assets/img/hhg.png" alt="image">
							<div class="portfolio_item_hover">
								<div class="item_info">
									<span>HALF HUMAN GAMES</span>
									<v-btn flat @click.stop="dialog11 = true">view</v-btn>
								</div>
							</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog11" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items11" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat xs12 md5 class="col-md-5" style="background-color: white !important;">
										<h4>{{items11[0].title}}</h4>
										<p class="portP">{{items11[0].subtitle}}</p>
										<p class="portP">{{items11[0].description}}</p>
										<p class="portP"><span style="font-weight: 700;">Tools: </span>{{items11[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="https://halfhumangames.com" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					<!-- end single work -->
					<!-- single work -->
					<div class="col-md-4 vue mongo vuetify express node">
						<div class="portfolio_item work-grid">
							<img src="/static/assets/img/ollert1.png" alt="image">
							<div class="portfolio_item_hover">
								<div class="item_info">
									<span>Ollert</span>
									<v-btn flat @click.stop="dialog14 = true">view</v-btn>
								</div>
							</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog14" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items14" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat xs12 md5 class="col-md-5" style="background-color: white !important;">
										<h4>{{items14[0].title}}</h4>
										<p class="portP">{{items14[0].subtitle}}</p>
										<p class="portP">For demo, log in as <strong>ollert</strong><br> Password:  <strong>test1234</strong></p>
										<!-- <p class="portP">{{items14[0].description}}</p> -->
										<p class="portP"><span style="font-weight: 700;">Tools: </span>{{items14[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="https://ollert.vercel.app/" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					<!-- end single work -->
					<!-- single work -->
					<div class="col-md-4 bootstrap">
						<div class="portfolio_item work-grid">
							<img src="/static/assets/img/foodie1.png" alt="image">
							<div class="portfolio_item_hover">
								<div class="item_info">
									<span>I EAT FOOD</span>
									<v-btn flat @click.stop="dialog4 = true">view</v-btn>
								</div>
							</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog4" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items4" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat class="col-md-5" style="background-color: white !important;">
										<h4>{{items4[0].title}}</h4>
										<p class="portP">{{items4[0].subtitle}}</p>
										<p class="portP">{{items4[0].description}}</p>
										<p class="portP"> <span style="font-weight: 700;">Tools: </span>{{items4[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="https://i-eat-food.herokuapp.com/index.html" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					<!-- end single work -->

					<!-- single work -->
					<div class="col-md-4 vue bootstrap">
						<div class="portfolio_item work-grid">
							<img src="/static/assets/img/fas2.png" alt="image">
							<div class="portfolio_item_hover">
								<div class="item_info">
									<span>FAESAL</span>
									<v-btn flat @click.stop="dialog5 = true">view</v-btn>
								</div>
							</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog5" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items5" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat class="col-md-5" style="background-color: white !important;">
										<h4>{{items5[0].title}}</h4>
										<p class="portP">{{items5[0].subtitle}}</p>
										<p class="portP">{{items5[0].description}}</p>
										<p class="portP"><span style="font-weight: 700;">Tools: </span>{{items5[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="https://faesalshehab.herokuapp.com/#/" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					<!-- end single work -->
					<!-- single work -->
					<div class="col-md-4 vue bootstrap">
						<div class="portfolio_item work-grid">
							<img src="/static/assets/img/jones1.png" alt="image">
							<div class="portfolio_item_hover">
								<div class="item_info">
									<span>BRANDEN</span>
									<v-btn flat @click.stop="dialog6 = true">view</v-btn>
								</div>
							</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog6" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items6" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat class="col-md-5" style="background-color: white !important;">
										<v-card-text>	<h4>{{items6[0].title}}</h4></v-card-text>
									
										<p class="portP">{{items6[0].subtitle}}</p>
										<p class="portP">{{items6[0].description}}</p>
										<p class="portP"><span style="font-weight: 700;">Tools: </span>{{items6[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="https://branden-portfolio.herokuapp.com/#/" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					<!-- end single work -->
					<!-- single work -->
					<div class="col-md-4 vue bootstrap">
						<div class="portfolio_item work-grid">
							<img src="/static/assets/img/taste1.png" alt="image">
							<div class="portfolio_item_hover">
								<div class="item_info">
									<span>TASTE OF SPAIN</span>
									<v-btn flat @click.stop="dialog7 = true">view</v-btn>
								</div>
							</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog7" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items7" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat class="col-md-5" style="background-color: white !important;">
										<h4>{{items7[0].title}}</h4>
										<p class="portP">{{items7[0].subtitle}}</p>
										<p class="portP">{{items7[0].description}}</p>
										<p class="portP"><span style="font-weight: 700;">Tools: </span>{{items7[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="https://taste-of-spain.herokuapp.com/" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					<!-- end single work -->
					
					
					
					<!-- single work -->
					<div class="col-md-4 vuetify vue">
						<div class="portfolio_item work-grid">
							<img src="/static/assets/img/port1.png" alt="malaikakunle">
							<div class="portfolio_item_hover">
								<div class="item_info">
									<span>malaika</span>
									<v-btn flat @click.stop="dialog3 = true">view</v-btn>
								</div>
							</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog3" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items3" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat class="col-md-5" style="background-color: white !important;">
										<h4>{{items3[0].title}}</h4>
										<p class="portP">{{items3[0].subtitle}}</p>
										<p class="portP">{{items3[0].description}}</p>
										<p class="portP"><span style="font-weight: 700;">Tools: </span>{{items3[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="http://malaikakunle2.herokuapp.com/" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					<!-- end single work -->
					<!-- single work -->
					<div class="col-md-4 mongo vue express node bulma">
							<div class="portfolio_item work-grid">
								<img src="/static/assets/img/corgi1.png" alt="image">
								<div class="portfolio_item_hover">
									<div class="item_info">
										<span>Corgi Messageboard</span>
										<v-btn flat @click.stop="dialog13 = true">view</v-btn>
									</div>
								</div>
						</div>
					</div>
					<v-flex xs12 >
						<v-dialog v-model="dialog13" max-width="1000px" style="background-color: white;">
							<v-card flat style="background-color: white !important;">
								<v-layout row wrap align-center>
									<v-flex xs12 md7>
										<v-card flat style="padding: 50px;" >
											<v-carousel hide-delimiters style="height: 436px;width: 525px;">
													<v-carousel-item v-for="(item,i) in items13" v-bind:src="item.src" :key="i"></v-carousel-item>
											</v-carousel>
										</v-card>
									</v-flex>
									<v-card flat class="col-md-5" style="background-color: white !important;">
										<h4>{{items13[0].title}}</h4>
										<p class="portP">{{items13[0].subtitle}}</p>
										<p class="portP">{{items13[0].description}}</p>
										<p class="portP"><span style="font-weight: 700;">Tools: </span>{{items13[0].tools}}</p>
										<v-card-actions>
											<a style="text-decoration: none;" href="https://messageboard.malaika787.now.sh/" target="_blank"><span>VIEW SITE</span></a>
										</v-card-actions>
									</v-card>
								</v-layout>
							</v-card>
						</v-dialog>
					</v-flex>
					<!-- end single work -->

				</div>
				<!-- end row -->
			</div>
			
			<!-- all works end -->
		</div>
		<!-- end container -->
	</section>
</v-app>
</template>

<script>
export default {
  name: "Portfolio",
  data() {
    return {
      	msg: "",
		dialog: false,
		dialog2: false,
		dialog3: false,
		dialog4: false,
		dialog5: false,
		dialog6: false,
		dialog7: false,
		dialog8: false,
		dialog9: false,
		dialog10: false,
		dialog11: false,
		dialog12: false,
		dialog13: false,
		dialog14: false,

      items: [
        {
          title: "Bashor & Legendre, LLP",
          subtitle: "Certified Public Accountants (CPAs)",
          description:
            "Bashor & Legendre, LLP, Certified Public Accountants (CPAs), is a full service accounting, tax and consulting firm.",
          tools: "VueJs + NodeJS + Vuetify",
          src: "/static/assets/img/bash1.png"
        },
        {
          src: "/static/assets/img/bash2.png"
        },
        {
          src: "/static/assets/img/bashfooter.png"
        },
        {
          src: "/static/assets/img/bashindustries.png"
        },
        {
          src: "/static/assets/img/bashmobile.png"
        }
      ],
      items2: [
        {
          title: "Quickr Lists",
          subtitle: "Easy task management",
          description:
            "Quickr Lists is a task list for everyday use. It is truly usable with great user experience.",
          tools: "Angular + NodeJS + ExpressJS + MongoDB",
          src: "/static/assets/img/quickrlists1.png"
        },
        {
          src: "/static/assets/img/quickrlists2.png"
		},
        {
          src: "/static/assets/img/quickrlists3.png"
        }
      ],
      items3: [
        {
          title: "Malaika",
          subtitle: "Personal Project",
          description: "Portfolio Concept",
          tools: "VueJS + Vuetify + BootstrapVue",
          src: "/static/assets/img/port1.png"
        },
        {
          src: "/static/assets/img/port2.png"
        }
      ],
      items4: [
        {
          title: "I EAT FOOD",
          subtitle: "Foodie blog",
          description: "A small project designed for a food enthusiast.",
          tools: "HTML5 + Bootstrap4 + SASS",
          src: "/static/assets/img/foodie1.png"
        },
        {
          src: "/static/assets/img/foodie3.png"
        },
        {
          src: "/static/assets/img/foodie4.png"
        },
        {
          src: "/static/assets/img/foodie6.png"
        }
      ],
      items5: [
        {
          title: "Faesal Shehab",
          subtitle: "Online Portfolio",
          description: "A portfolio designed for a mechanical engineer.",
          tools: "VueJS + HTML5 + Bootstrap4 + JQuery",
          src: "/static/assets/img/fas1.png"
        },
        {
          src: "/static/assets/img/fas2.png"
        },
        {
          src: "/static/assets/img/fas3.png"
        },
        {
          src: "/static/assets/img/fas4.png"
        }
      ],
      items6: [
        {
          title: "Branden Jones",
          subtitle: "Online Portfolio",
          description: "A portfolio designed for a mechanical engineer.",
          tools: "VueJS + HTML5 + Bootstrap4 + JQuery",
          src: "/static/assets/img/jones1.png"
        },
        {
          src: "/static/assets/img/jones2.png"
        },
        {
          src: "/static/assets/img/jones3.png"
        },
        {
          src: "/static/assets/img/jones4.png"
        }
      ],
      items7: [
        {
          title: "Taste of Spain",
          subtitle: "Gourmet On-Site Cooking",
          description:
            "Taste of Spain is a full service catering company, serving the Tampa Bay Area and beyond. ",
          tools: "VueJS + HTML5 + Bootstrap4 + JQuery",
          src: "/static/assets/img/taste1.png"
        },
        {
          src: "/static/assets/img/taste2.png"
        },
        {
          src: "/static/assets/img/taste3.png"
        },
        {
          src: "/static/assets/img/taste4.png"
        }
      ],
      items8: [
        {
          title: "MK Rehab Center",
          subtitle: "Addiction Recovery Center",
          description:
            "MK Rehab Center is a sample rehabilation company, serving the Tampa Bay Area and beyond. ",
          tools: "Wordpress",
          src: "/static/assets/img/rehab1.png"
        },
        {
          src: "/static/assets/img/rehab2.png"
        },
        {
          src: "/static/assets/img/rehab3.png"
        },
        {
          src: "/static/assets/img/rehab4.png"
        },
        {
          src: "/static/assets/img/rehab5.png"
        }
      ],
      items9: [
        {
          title: "Shea Bath & Body",
          subtitle: "Your Life. Your Body. Your Skin",
          description:
            "Shea Bath & Body is a handmade bath products company located in Tampa, Florida. This wife and husband team is dedicated to making high quality vegan and ecofriendly items that work great and smell amazing at the same time.",
          tools: "VueJS + HTML5 + Bootstrap4 + JQuery",
          src: "/static/assets/img/shea1.png"
        },
        {
          src: "/static/assets/img/shea2.png"
        },
        {
          src: "/static/assets/img/shea3.png"
        },
        {
          src: "/static/assets/img/shea4.png"
        },
        {
          src: "/static/assets/img/shea5.png"
        }
      ],      items10: [
        {
          title: "Dwerve",
          subtitle: "Tower Defense Dungeon Crawler",
          description:
            "Dwerve is a singleplayer tower-defense dungeon crawler RPG in which the player assumes the role of a dwarven Warsmith, or war-engineer, named Dwerve.",
          tools: "VueJS + Bootstrap4 + JQuery",
          src: "/static/assets/img/dwerve1.png"
        },
        {
          src: "/static/assets/img/dwerve2.png"
        },
        {
          src: "/static/assets/img/dwerve3.png"
        }
			],
      items11: [
        {
          title: "Half Human Games",
          subtitle: "Indie Game Studio",
          description:
            "Two independent game developers, PJ Legendre and Peter Milko formed Half Human Games around an idea for dungeon crawler RPG that ditched hack n' slash and turned-based combat for tower defense style combat.",
          tools: "VueJs + Bulma",
          src: "/static/assets/img/hhg.png"
        }
		],
		items12: [
        {
          title: "Cyber Dream VR",
          subtitle: "VR Game Development Studio",
          description:
            "Cyber Dream is a VR game development studio, employing professionals and game enthusiasts fascinated with the capabilities of virtual reality.",
          tools: "Wordpress",
          src: "/static/assets/img/cyber1.png"
        },
        {
          src: "/static/assets/img/cyber2.png"
        },
        {
          src: "/static/assets/img/cyber3.png"
        }
        
	  ],
	  items13: [
        {
          title: "Corgi Messageboard",
          subtitle: "An online community for corgi enthusiasts",
          description:
            "Corgi Messageboard is an online community for corgi enthusiasts, shelters, rescue organizations, volunteers, fosters, and adopters to share information.",
          tools: "Bulma + NodeJS + ExpressJS + MongoDB",
          src: "/static/assets/img/corgi1.png"
        },
        {
          src: "/static/assets/img/corgi2.png"
        },
        {
          src: "/static/assets/img/corgi3.png"
        }
        
      ],
	  items14: [
        {
          title: "Ollert",
          subtitle: "A Trello Clone",
          description:
            "Corgi Messageboard is an online community for corgi enthusiasts, shelters, rescue organizations, volunteers, fosters, and adopters to share information.",
          tools: "VueJs + NodeJS + ExpressJS + MongoDB",
          src: "/static/assets/img/ollert1.png"
        },
        {
          src: "/static/assets/img/ollert2.png"
        },
        {
          src: "/static/assets/img/ollert3.png"
        },
		{
          src: "/static/assets/img/ollert4.png"
        }
        
      ],

    };
  }
};
</script>

<style scoped>
.dialog.dialog--active {
  background-color: white !important;
}

.portP {
  color: black;
}

@media only screen and (max-width: 600px) {
  .carousel {
    height: 353px !important;
    width: 338px !important;
  }
  .card.card--flat {
    padding: 14px !important;
  }
}
@media only screen and (width: 768px) {
  .carousel {
    height: 514px !important;
    width: 674px !important;
  }
  .card.card--flat {
    padding: 20px !important;
  }
}
.portfolio h2 {
    text-transform: uppercase;
    letter-spacing: 5px;
    color: #000;
    font-size: 40px;
    font-weight: 700;
    text-align: center;
    margin-top: -145px;
    margin-bottom: 100px;
}
section#portfolio .col-md-3 {
    float: left;
}
section#portfolio .col-md-9 {
    float: left;
}
.portfolio_item.work-grid {
    box-shadow: 0 0.5em 1em -0.125em rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.02);
}
.portfolio_container img {
    width: 100%;
    min-height: 182px;
    object-fit: cover;
}
.portfolio .categories-grid .categories ul li a:before {
    background: #fff;
    border-radius: 10px;
    box-shadow: inset 0 1px rgba(0, 0, 0, 0.25);
    content: '';
    height: 6px;
    left: 10px;
    position: absolute;
    width: 6px;
    top: 10px;
}
.portfolio .categories-grid .categories ul li a:after {
    background: #fafafa;
    border-bottom: 13px solid transparent;
    border-left: 10px solid #eee;
    border-top: 13px solid transparent;
    content: '';
    position: absolute;
    right: 0;
    top: 0;
}
.portfolio .categories-grid .categories ul li a:hover, .portfolio .categories-grid .categories ul li a.active {
    background-color: crimson;
    color: white;
}
.portfolio .categories-grid .categories ul li a {
    background: #eee;
    border-radius: 3px 0 0 3px;
    color: #999;
    display: inline-block;
    height: 26px;
    line-height: 26px;
    padding: 0 20px 0 23px;
    position: relative;
    margin: 0 10px 10px 0;
    text-decoration: none;
    transition: color 0.2s ease;
}
.portfolio .categories-grid .categories ul li a:hover::after, .portfolio .categories-grid .categories ul li a.active:after {
   border-left-color: crimson; 
       width: auto;
}
ul.portfolio_filter {
    display: flex;
    flex-wrap: wrap;
    justify-content: end;
}
.portfolio .categories-grid .categories ul li {
    list-style: none;
    margin: 7px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Portfolio.vue